function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "#666",
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M7.47 21.975l8.136 8.807a.497.497 0 00.73 0l8.136-8.807c1.245-1.348 2.162-2.827 2.726-4.397.575-1.575.817-3.256.712-4.934a12.808 12.808 0 00-3.612-8.13A11.662 11.662 0 0015.97 1c-3.125 0-6.12 1.264-8.327 3.513a12.81 12.81 0 00-3.612 8.131 12.168 12.168 0 00.712 4.934c.564 1.57 1.48 3.05 2.726 4.397zm-2.437-9.263a11.783 11.783 0 013.321-7.479 10.668 10.668 0 017.617-3.214c2.858 0 5.599 1.157 7.616 3.214a11.782 11.782 0 013.322 7.48 11.135 11.135 0 01-.654 4.516c-.516 1.44-1.362 2.801-2.514 4.048l-7.77 8.412-7.77-8.412C7.05 20.03 6.203 18.668 5.686 17.23a11.142 11.142 0 01-.653-4.517z",
  stroke: "#666",
  strokeWidth: 0.2
}), React.createElement("path", {
  d: "M15.97 21.193c4.58 0 8.306-3.883 8.306-8.654 0-4.772-3.726-8.655-8.305-8.655-4.58 0-8.305 3.882-8.305 8.654s3.726 8.655 8.305 8.655zm0-16.29c4.027 0 7.303 3.426 7.303 7.635 0 4.21-3.276 7.635-7.302 7.635s-7.302-3.425-7.302-7.635 3.276-7.634 7.302-7.634z",
  stroke: "#666",
  strokeWidth: 0.2
}), React.createElement("path", {
  d: "M14.627 15.118c.193.196.504.2.701.008l4.571-4.438a.516.516 0 00.017-.72.495.495 0 00-.71-.017l-4.216 4.094-2.246-2.284a.496.496 0 00-.71 0 .516.516 0 000 .721l2.593 2.636z"
}));

var SvgIcNavCompleted = function SvgIcNavCompleted(props) {
  return React.createElement("svg", _extends({
    width: 32,
    height: 32
  }, props), _ref);
};

export default __webpack_public_path__ + "346e6161274e37181101745d961f1ef3.svg";
export { SvgIcNavCompleted as ReactComponent };